import React from 'react'
import { AiFillEdit, AiOutlineFileGif, AiOutlineMail, AiOutlineShareAlt } from 'react-icons/ai';
import { BiFilterAlt } from 'react-icons/bi';
import { BsChat } from 'react-icons/bs';
import { FiSettings } from 'react-icons/fi';
import { MdDesktopWindows, MdAspectRatio } from 'react-icons/md';
import { FaChessQueen, FaRegClosedCaptioning } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { ImFilm } from 'react-icons/im';
import { IoMdGift } from 'react-icons/io';

function NewFormWziardChild() {

  const { event_option } = useSelector((state => state.createEvent))
  const location = useLocation()

  const eventOption = location.pathname === '/event/options' ||
    location.pathname === '/event/social' ||
    location.pathname === '/event/gif' ||
    location.pathname === '/event/brust-gif' ||
    location.pathname === '/event/email' ||
    location.pathname === '/event/sms' ||
    location.pathname === '/event/digital-prop' ||
    location.pathname === '/event/custom-branding' ||
    location.pathname === '/event/microsite' ||
    location.pathname === '/event/frame' ||
    location.pathname === '/event/video-frame' ||
    location.pathname === '/event/boomerang-frame' ||
    location.pathname === '/event/incentive-offer' ||
    location.pathname === '/event/filter' ||
    location.pathname === '/event/form-builder' 

  const eventSocial = location.pathname === '/event/social' ||
    location.pathname === '/event/gif' ||
    location.pathname === '/event/brust-gif' ||
    location.pathname === '/event/email' ||
    location.pathname === '/event/sms' ||
    location.pathname === '/event/digital-prop' ||
    location.pathname === '/event/custom-branding' ||
    location.pathname === '/event/microsite' ||
    location.pathname === '/event/frame' ||
    location.pathname === '/event/video-frame' ||
    location.pathname === '/event/boomerang-frame' ||
    location.pathname === '/event/incentive-offer' ||
    location.pathname === '/event/filter' ||
    location.pathname === '/event/form-builder' 

  const eventGif = location.pathname === '/event/gif' ||
    location.pathname === '/event/brust-gif' ||
    location.pathname === '/event/email' ||
    location.pathname === '/event/sms' ||
    location.pathname === '/event/digital-prop' ||
    location.pathname === '/event/custom-branding' ||
    location.pathname === '/event/microsite' ||
    location.pathname === '/event/frame' ||
    location.pathname === '/event/video-frame' ||
    location.pathname === '/event/boomerang-frame' ||
    location.pathname === '/event/incentive-offer' ||
    location.pathname === '/event/filter' ||
    location.pathname === '/event/form-builder' 

  const eventBrustGif = location.pathname === '/event/brust-gif' ||
    location.pathname === '/event/email' ||
    location.pathname === '/event/sms' ||
    location.pathname === '/event/digital-prop' ||
    location.pathname === '/event/custom-branding' ||
    location.pathname === '/event/microsite' ||
    location.pathname === '/event/frame' ||
    location.pathname === '/event/video-frame' ||
    location.pathname === '/event/boomerang-frame' ||
    location.pathname === '/event/incentive-offer' ||
    location.pathname === '/event/filter' ||
    location.pathname === '/event/form-builder' 

  const eventEmail = location.pathname === '/event/email' ||
    location.pathname === '/event/sms' ||
    location.pathname === '/event/digital-prop' ||
    location.pathname === '/event/custom-branding' ||
    location.pathname === '/event/microsite' ||
    location.pathname === '/event/frame' ||
    location.pathname === '/event/video-frame' ||
    location.pathname === '/event/boomerang-frame' ||
    location.pathname === '/event/incentive-offer' ||
    location.pathname === '/event/filter' ||
    location.pathname === '/event/form-builder' 

  const eventTextSMS = location.pathname === '/event/sms' ||
    location.pathname === '/event/digital-prop' ||
    location.pathname === '/event/custom-branding' ||
    location.pathname === '/event/microsite' ||
    location.pathname === '/event/frame' ||
    location.pathname === '/event/video-frame' ||
    location.pathname === '/event/boomerang-frame' ||
    location.pathname === '/event/incentive-offer' ||
    location.pathname === '/event/filter' ||
    location.pathname === '/event/form-builder' 

  const eventDigitalProp = location.pathname === '/event/digital-prop' ||
    location.pathname === '/event/custom-branding' ||
    location.pathname === '/event/microsite' ||
    location.pathname === '/event/frame' ||
    location.pathname === '/event/video-frame' ||
    location.pathname === '/event/boomerang-frame' ||
    location.pathname === '/event/incentive-offer' ||
    location.pathname === '/event/filter' ||
    location.pathname === '/event/form-builder' 

  const eventWaterMark = location.pathname === '/event/custom-branding' ||
    location.pathname === '/event/microsite' ||
    location.pathname === '/event/frame' ||
    location.pathname === '/event/video-frame' ||
    location.pathname === '/event/boomerang-frame' ||
    location.pathname === '/event/incentive-offer' ||
    location.pathname === '/event/filter' ||
    location.pathname === '/event/form-builder' 

  const eventMicroSite = location.pathname === '/event/microsite' ||
    location.pathname === '/event/frame' ||
    location.pathname === '/event/video-frame' ||
    location.pathname === '/event/boomerang-frame' ||
    location.pathname === '/event/incentive-offer' ||
    location.pathname === '/event/filter' ||
    location.pathname === '/event/form-builder' 

  const eventFrame = location.pathname === '/event/frame' ||
    location.pathname === '/event/video-frame' ||
    location.pathname === '/event/boomerang-frame' ||
    location.pathname === '/event/incentive-offer' ||
    location.pathname === '/event/incentive-offer' ||
    location.pathname === '/event/filter' ||
    location.pathname === '/event/form-builder' 

  const eventVideoFrame = location.pathname === '/event/video-frame' ||
    location.pathname === '/event/boomerang-frame' ||
    location.pathname === '/event/incentive-offer' ||
    location.pathname === '/event/filter' ||
    location.pathname === '/event/form-builder' 

  const eventBoomerangFrame = location.pathname === '/event/boomerang-frame' ||
    location.pathname === '/event/incentive-offer' ||
    location.pathname === '/event/filter' ||
    location.pathname === '/event/form-builder'

  const incentiveOffer = location.pathname === '/event/incentive-offer' ||
    location.pathname === '/event/filter' ||
    location.pathname === '/event/form-builder' 

  const eventFilter = location.pathname === '/event/filter' || location.pathname === '/event/form-builder'
  const eventFormBuilder = location.pathname === '/event/form-builder'


  return (
    <>
      <div className="form-wizard-section">
        <div id="smartwizard1" className="sw-main sw-theme-arrows">
          <ul className="nav nav-tabs step-anchor">
            <li className={`${eventOption ? 'active' : 'done'}`}>
              <span>
                <span className="rounded-btn">
                  <FiSettings size={20} />
                </span>{" "}
                  Event Option
                </span>
            </li>

            {event_option.social_media === true ?
              <li className={`${eventSocial ? 'active' : 'done'}`}>
                <span>
                  <span className="rounded-btn">
                    <AiOutlineShareAlt size={20} />
                  </span>{" "}Social Media
                  </span>
              </li>
              : ""}
            
            {event_option.gif === true ?
              <li className={`${eventGif ? 'active' : 'done'}`}>
                <span>
                  <span className="rounded-btn">
                    <AiOutlineFileGif size={20} />
                  </span>{" "}
                  3 in 1 Animation
                </span>
              </li>
              : ""}

            {event_option.brust_gif === true ?
              <li className={`${eventBrustGif ? 'active' : 'done'}`}>
                <span>
                  <span className="rounded-btn">
                    <ImFilm size={20} />
                  </span>{" "}
                  3 in 1 Fast
                </span>
              </li>
              : ""}

            {event_option.email === true ?
              <li className={`${eventEmail ? 'active' : 'done'}`}>
                <span>
                  <span className="rounded-btn">
                    <AiOutlineMail size={20} />
                  </span>{" "}
                  Email
                </span>
              </li>
              : ""}

            {event_option.text_messaging === true ?
              <li className={`${eventTextSMS ? 'active' : 'done'}`}>
                <span>
                  <span className="rounded-btn">
                    <BsChat size={20} />
                  </span>{" "}
                  SMS
                </span>
              </li>
              : ""}

            {event_option.digital_props === true ?
              <li className={`${eventDigitalProp ? 'active' : 'done'}`}>
                <span>
                  <span className="rounded-btn">
                    <FaChessQueen size={20} />
                  </span>{" "}
                  Digital Props
                </span>
              </li>
              : ""}

            {event_option.water_mark === true ?
              <li className={`${eventWaterMark ? 'active' : 'done'}`}>
                <span>
                  <span className="rounded-btn">
                    <FaRegClosedCaptioning size={20} />
                  </span>{" "}
                  Custom Branding
                </span>
              </li>
              : ""}

            {event_option.microsite === true ?
              <li className={`${eventMicroSite ? 'active' : 'done'}`}>
                <span>
                  <span className="rounded-btn">
                    <MdDesktopWindows size={20} />
                  </span>{" "}
                  Social Gallery
                </span>
              </li>
              : ""}

            {event_option.frame_option === true ?
              <li className={`${eventFrame ? 'active' : 'done'}`}>
                <span>
                  <span className="rounded-btn">
                    <MdAspectRatio size={20} />
                  </span>{" "}
                  Frame
                </span>
              </li>
              : ""}
            
            {event_option.video_frame_option === true ?
              <li className={`${eventVideoFrame ? 'active' : 'done'}`}>
                <span>
                  <span className="rounded-btn">
                    <ImFilm size={20} />
                  </span>{" "}
                  Video Frame
              </span>
              </li>
              : ""}

            {event_option.boomerang_frame_option === true ?
              <li className={`${eventBoomerangFrame ? 'active' : 'done'}`}>
                <span>
                  <span className="rounded-btn">
                    <ImFilm size={20} />
                  </span>{" "}
                  Boomerang Frame
              </span>
              </li>
              : ""}
            
            {event_option.incentive_offer === true && (
              <li className={`${incentiveOffer ? 'active' : 'done'}`}>
                <span>
                  <span className="rounded-btn">
                    <IoMdGift size={20} />
                  </span>{" "}
                  Incentive Offer
              </span>
              </li>)}

            {event_option.filters === true && (
              <li className={`${eventFilter ? 'active' : 'done'}`}>
                <span>
                  <span className="rounded-btn">
                    <BiFilterAlt size={20} />
                  </span>{" "}
                Event Filter
              </span>
              </li>)}
            {event_option.form_builder === true && (
              <li className={`${eventFormBuilder ? 'active' : 'done'}`}>
                <span>
                  <span className="rounded-btn">
                    <AiFillEdit size={20} />
                  </span>{" "}
                Form Builder
              </span>
              </li>)}


          </ul>


        </div>
      </div>

    </>
  )
}

export default NewFormWziardChild
